import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Column"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 3H19.5V21H18V3ZM13.5 4.5V19.5H10.5V4.5H13.5ZM13.5 3H10.5C9.67157 3 9 3.67157 9 4.5V19.5C9 20.3284 9.67157 21 10.5 21H13.5C14.3284 21 15 20.3284 15 19.5V4.5C15 3.67157 14.3284 3 13.5 3ZM4.5 3H6V21H4.5V3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Column.vue"]]);
